import { FoodsTextInput } from "@foodpilot/foods";
import { FormControl, InputProps, Typography, useTheme } from "@mui/material";
import { useTranslation } from "react-i18next";
import { Controller, useFormContext } from "react-hook-form";

type IFormInputProps = {
    name: string;
    label: string;
    placeholder?: string;
    hideError?: boolean;
} & InputProps;

export const FormInput = (props: IFormInputProps) => {
    const { t } = useTranslation();
    const theme = useTheme();
    const methods = useFormContext();

    const { name, label, placeholder, hideError = false, ...otherProps } = props;
    const { error } = methods.getFieldState(name, methods.formState);

    return (
        <Controller
            defaultValue={otherProps.defaultValue ?? ""}
            control={methods.control}
            name={name}
            render={({ field }) => (
                <FormControl
                    fullWidth
                    sx={{
                        "> div": {
                            gap: "8px !important",
                        },
                    }}
                >
                    <Typography variant="body-bold">{label}</Typography>
                    <FoodsTextInput
                        value={field.value}
                        onChange={field.onChange}
                        ExtraInputProps={{
                            ...otherProps,
                        }}
                    />
                    {error && !hideError && (
                        <Typography variant="body" color="error">
                            {t("common.error_occurred", "An error occurred")}
                        </Typography>
                    )}
                </FormControl>
            )}
        />
    );
};
